import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import NestedSidebarMenu from "./NestedSidebarMenu/NestedSidebarMenu";

const SidebarCollapsableItem = ({ sidebarItem, ...props }) => {
  const { title, isCollapsable, heading, links } = sidebarItem;
  const [open, setOpen] = useState(true);
  const location = useLocation();

  return (
    <>
      <div className="sidebar-heading tw-text-[18px] tw-capitalize !tw-px-3 tw-hidden md:tw-block tw-text-white">
        {title}
      </div>
      <ul className="sidebar-menu !tw-my-0">
        <>
          <li className="sidebar-links-content open tw-p-2 tw-ps-0 tw-overflow-y-auto md:tw-max-h-[72vh] custom-scrollbar">
            {isCollapsable ? (
              <>
                <button
                  className="btn sidebar-menu-button !tw-text-secondary !tw-px-3 sidebar-js-collapse hover:!tw-text-white"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpen(!open);
                  }}
                >
                  <i className="sidebar-menu-icon !tw-text-2xl sidebar-menu-icon--left material-icons">
                    {heading.icon}
                  </i>
                  {heading?.title}
                  <span className="ml-auto sidebar-menu-toggle-icon"></span>
                </button>

                {links.length > 0 && (
                  <Collapse in={open}>
                    <ul>
                      {links?.map((el, elIndex) => (
                        <li
                          className={`sidebar-menu-item md:tw-my-1 ${
                            !el.isCollapsable && "hover:!tw-text-white"
                          } `}
                          key={elIndex}
                        >
                          {el.isCollapsable ? (
                            <NestedSidebarMenu el={el} />
                          ) : (
                            <Link
                              to={el.link}
                              className={`sidebar-menu-button !tw-ps-3 !tw-pe-0 ${
                                location.pathname === el.link
                                  ? "sidebar-active-color"
                                  : ""
                              }`}
                            >
                              <i className="sidebar-menu-icon--left !tw-text-[#B0B1B4] material-icons tw-size-6">
                                {el.icon}
                              </i>
                              {el.title}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </Collapse>
                )}
              </>
            ) : (
              <>
                {links.length > 0 && (
                  <ul>
                    {links?.map((el, elIndex) => (
                      <li className="sidebar-menu-item" key={elIndex}>
                        <Link
                          to={el.link}
                          className="sidebar-menu-button hover:!tw-text-white"
                        >
                          {el.icon && (
                            <i className="sidebar-menu-icon sidebar-menu-icon--left material-icons">
                              {el.icon}
                            </i>
                          )}{" "}
                          {el.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </>
            )}
          </li>
        </>
      </ul>
    </>
  );
};

export default SidebarCollapsableItem;
